<template>
    <div style="height: 100vh;" class="main">

        <slot name="page" >
            <div :class="{moveUp:true}">
                <div class="slogen">
                    <h1 style="display: block;width: 100vw">Hengchuang brings you different products and services
                    </h1>

                </div>
            </div>


        </slot>

    </div>
</template>

<script>

    export default {
        name: "Page1",
        data(){
            return{
                isPC:true

            }
        },
        created() {
            if (this._isMobile()) {
                if(this._isMobile().indexOf("iPad")!=-1){
                    this.isPC=true;
                }else {
                    this.isPC=false;
                }

            } else {
                // alert("pc端");
                // this.$router.replace('/test');
                this.isPC=true;
            }
        },
        methods:{
            _isMobile() {
                let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
                return flag;
            },

        }

    }
</script>

<style scoped>


    .slogen{
        width: 100vw;
        height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        z-index: 888;
        position: absolute;
        top: 0;
        left: 0;
        overflow: hidden;
        font-size: 1.8rem;
        color: white;


    }
    .main{
        height: 100%;
        width: 100%;
        background-image: url("../../assets/about.jpg") ;
        background-size: 100% 100%;
        background-repeat:no-repeat ;
        background-color: #cccccc;
        position: relative;
    }
</style>